var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInstalledPackagesIcon = function SvgInstalledPackagesIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#InstalledPackagesIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.456 3.6q1.245 0 1.813.566.577.556.577 1.537 0 .444-.127.85a1.9 1.9 0 0 1-.423.716 1.96 1.96 0 0 1-.767.491q-.478.18-1.181.18h-.586v2.395H3.4V3.6zm-.072 1.17h-.622v2h.45q.388 0 .668-.104.279-.105.433-.33.153-.227.153-.585 0-.502-.262-.736-.26-.246-.82-.246M8.269 5.185h1.47l.928 2.896q.046.14.073.283.036.141.054.292.027.15.036.321h.027q.027-.246.072-.462.054-.227.117-.434l.911-2.896H13.4l-2.083 5.81a2.8 2.8 0 0 1-.496.888 1.9 1.9 0 0 1-.694.537q-.398.18-.866.18-.226 0-.397-.029a3 3 0 0 1-.289-.047v-1.113q.1.019.235.038.144.018.297.018.28 0 .478-.122.208-.123.343-.34.135-.207.216-.453l.082-.254z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    x: 0.5,
    y: 0.5,
    stroke: "currentColor",
    rx: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "InstalledPackagesIcon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgInstalledPackagesIcon;